import type { AlfaAuthConfig } from './socialNetworkUtils';

export const createAlfaAuthUrl = (
  config: AlfaAuthConfig,
  validationState: string,
  isSeamlessAuthorization = false,
) => {
  const params = [
    'response_type=code',
    `client_id=${config.client_id}`,
    isSeamlessAuthorization
      ? `redirect_uri=${window.location.origin}`
      : `redirect_uri=${window.location.origin}/login/alfabank`,
    `scope=openid profile email phone`,
    `state=${validationState}`,
  ].join('&');

  return `https://id.alfabank.ru/oidc/authorize?${params}`;
};
